import greenImg from "../assets/img/case/green-case.png";
import luckyImg from "../assets/img/case/lucky-case.png";
import mediumImg from "../assets/img/case/medium.png";
import busterImg from "../assets/img/busters/buster.png";
import eggImg1 from "../assets/img/eggs/puertosaur.png";
import eggImg2 from "../assets/img/eggs/spinosaur.png";
import { dinosaurGrowths, dinosaurTypes, megaShopTypes } from "./consts";
import austroImg from "../assets/img/dinosaur/Австро.png";
import aloImg from "../assets/img/dinosaur/Ало.png";
import bapeImg from "../assets/img/dinosaur/Бейп.png";
import galyaImg from "../assets/img/dinosaur/Галя.png";
import geroImg from "../assets/img/dinosaur/геро.png";
import gipsImg from "../assets/img/dinosaur/гипс.png";
import dainImg from "../assets/img/dinosaur/дейн.png";
import diabloImg from "../assets/img/dinosaur/диабло.png";
import diloImg from "../assets/img/dinosaur/дило.png";
import drioImg from "../assets/img/dinosaur/дрио.png";
import carImg from "../assets/img/dinosaur/кар.png";
import maikaImg from "../assets/img/dinosaur/майка.png";
import oviImg from "../assets/img/dinosaur/Ови.png";
import omniImg from "../assets/img/dinosaur/омни.png";
import pahImg from "../assets/img/dinosaur/Пах.png";
import pterImg from "../assets/img/dinosaur/Птер.png";
import recsImg from "../assets/img/dinosaur/Рекс.png";
import stegImg from "../assets/img/dinosaur/Стег.png";
import tenImg from "../assets/img/dinosaur/тен.png";
import toroImg from "../assets/img/dinosaur/торо.png";
import tcerImg from "../assets/img/dinosaur/цер.png";

const casesData = [
  {
    image: luckyImg,
    teeth: 75,
    oa: 300,
  },
  {
    image: greenImg,
    teeth: 50,
    oa: 200,
  },
  {
    image: mediumImg,
    teeth: 100,
    oa: 400,
  },
];

casesData.forEach((item) => {
  item.type = megaShopTypes.case;
});

const bustersData = [
  {
    image: busterImg,
    teeth: 50,
    oa: 200,
  },
];

bustersData.forEach((item) => {
  item.type = megaShopTypes.buster;
});

const eggsData = [
  {
    image: eggImg1,
    teeth: 100,
    oa: 400,
  },
  {
    image: eggImg2,
    teeth: 50,
    oa: 200,
  },
];

eggsData.forEach((item) => {
  item.type = megaShopTypes.egg;
});

// const dinosaursData2 = [
//   {
//     image: dinosaurImg1,
//     tier: 1,
//     name: "Пситтакозавр",
//     type: dinosaurTypes.herbivorous,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Sub,
//     weight: 50,
//     damage: 25,
//     speed: 29.3,
//     mode: "Progrssion",
//     endurance: "1 - 175",
//     hunger: "0 - 15",
//     thirst: "0 - 20",
//     server: "Legacy",
//     health: "25 - 25",
//     buyTime: "07 декабря 2024, 11:52",
//     appearance: "Добавление джува в слот",
//     updated: "07 декабря 2024, 11:52",
//     genom: "1.0",
//     feature: "Обычный динозавр",
//     coordinates: "Доступен спавн",
//     id: 2171588,
//     slotId: 643314,
//   },
//   {
//     image: dinosaurImg2,
//     tier: 2,
//     name: "ХВОСТОЕБ",
//     type: dinosaurTypes.herbivorous,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Sub,
//     weight: 25000,
//   },
//   {
//     image: dinosaurImg3,
//     tier: 1,
//     name: "Авацератопс",
//     type: dinosaurTypes.herbivorous,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Adult,
//     weight: 1000,
//     damage: 25,
//     speed: 29.3,
//     mode: "Progrssion",
//     endurance: "1 - 130",
//     hunger: "0 - 120",
//     thirst: "0 - 50",
//     server: "Legacy",
//     health: "1000 - 1000",
//   },
//   {
//     image: dinosaurImg4,
//     tier: 4,
//     name: "ОРЕАЛКИН",
//     type: dinosaurTypes.herbivorous,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Adult,
//     weight: 2500,
//   },
//   {
//     image: dinosaurImg5,
//     tier: 1,
//     name: "СМОТРЯЩИЙ",
//     type: dinosaurTypes.predator,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Adult,
//     weight: 2000,
//   },
//   {
//     image: dinosaurImg6,
//     tier: 1,
//     name: "Ютараптор",
//     type: dinosaurTypes.predator,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Adult,
//     weight: 1000,
//     damage: 200,
//     speed: 43,
//     mode: "Progrssion",
//     endurance: "200 - 300",
//     hunger: "75 - 300",
//     thirst: "45 - 60",
//     server: "Legacy",
//     health: "300 - 1200",
//     growthTime: 60,
//     description: `Юта довольно социальное животное, предпочитающее жить и охотиться в больших стаях. Может одна особь и не доставит особых проблем своему оппоненту, но стоит им собраться группой и беды уже не миновать. Свое слабое здоровье и силу укуса они компенсируют скоростью и маневренностью. Кроме этого, благодаря хорошо развитым мышцам ног, Юта способна довольно высоко прыгать, что делает ее еще более проблемной мишенью. Так же считается самым "плодовитым" динозавром на острове. В еде Ютараптор не привередлив и питается абсолютно всеми видами останков.

// Плюсы

// +Прыжки

// +Высокая Скорость

// +Хорошая Маневренность

// +Большая Выносливость

// Минусы

// -Низкий Урон

// -Низкий урон Кровью

// -Малое количество Здоровья

// -Слабая регенерация Здоровья

// -Долгая регенерация Крови`,
//   },
//   {
//     image: dinosaurImg7,
//     tier: 3,
//     name: "ШМЕНАТОПС",
//     type: dinosaurTypes.predator,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Sub,
//     weight: 1000,
//   },
//   {
//     image: dinosaurImg8,
//     tier: 4,
//     name: "НОРМИС",
//     type: dinosaurTypes.predator,
//     teeth: 75,
//     oa: 300,
//     growth: dinosaurGrowths.Sub,
//     weight: 500,
//   },
// ];

// export const catalogData = [
//   ...casesData,
//   ...bustersData,
//   ...eggsData,
//   ...dinosaursData2,
// ];
// catalogData.forEach((item, i) => {
//   item.id = i + 1;
// });

// export const testDinosaurData = {
//   image: dinosaurImg1,
//   tier: 1,
//   name: "Пситтакозавр",
//   type: dinosaurTypes.herbivorous,
//   teeth: 75,
//   oa: 300,
//   growth: dinosaurGrowths.Sub,
//   weight: 50,
//   damage: 25,
//   speed: 29.3,
//   mode: "Progrssion",
//   endurance: "1 - 175",
//   hunger: "0 - 15",
//   thirst: "0 - 20",
//   server: "Legacy",
//   health: "25 - 25",
//   buyTime: "07 декабря 2024, 11:52",
//   appearance: "Добавление джува в слот",
//   updateTime: "07 декабря 2024, 11:52",
//   genom: "1.0",
//   feature: "Обычный динозавр",
//   coordinates: "Доступен спавн",
//   id: 2171588,
//   slotId: 643314,
// };

export const catalogCategoriesEng = {
  predator: "Плотоядные",
  herbivorous: "Травоядные",
  omnivorous: "Всеядные",
  items: "Предметы",
};

export const catalogCategories = {
  Плотоядные: "Плотоядные",
  Травоядные: "Травоядные",
  Всеядные: "Всеядные",
  Предметы: "Предметы",
};

export const catalogItemTypes = {
  dinosaurs: "Динозавр",
  items: "Предмет",
};

export const legacyCatalogCategoriesEng = {
  predator: "Плотоядные",
  herbivorous: "Травоядные",
  omnivorous: "Всеядные",
  items: "Предметы",
};

export const legacyCatalogCategories = {
  Плотоядные: "Плотоядные",
  Травоядные: "Травоядные",
  Всеядные: "Всеядные",
  //Предметы: "Предметы",
};

const dinosaursData = [
  {
    nameRu: "Дейнозух",
    name_eng: "Deinosuchus",
    cost: 300,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194544239925809204,
    emoji: 1222077808436711434,
    image_url: dainImg,
    is_visible: 1,
    id: 1,
    server: 1,
  },
  // {
  //   nameRu: "Древняя эссенция",
  //   name_eng: "Heal",
  //   cost: 50,
  //   item_type: "Предметы",
  //   category: "Предметы",
  //   grow: 0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1213921994488291390,
  //   emoji: 1253379484577693696,
  //   image_url:
  //     "https://cdn.discordapp.com/attachments/1197223722868805785/1215379517338550282/icons8-mana-96.png?ex=65fc8961&is=65ea1461&hm=bd43c909e7840d857e84b10896d69f92387a2aa7684dfeccfd20826f62c68fcd&",
  //   is_visible: 1,
  //   id: 2,
  //   server: 1,
  // },
  // {
  //   nameRu: "Желудок",
  //   name_eng: "HungerFull",
  //   cost: 20,
  //   item_type: "Предметы",
  //   category: "Предметы",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1216084118748790908,
  //   emoji: 1253410297516134522,
  //   image_url:
  //     "https://cdn.discordapp.com/attachments/1197223722868805785/1215379417250144346/icons8--96.png?ex=65fc8949&is=65ea1449&hm=813d8e7d15a8151c743b111daf4af1b93e125cdb6dfb582d748c14eac137e218&",
  //   is_visible: 1,
  //   id: 3,
  //   server: 1,
  // },
  // {
  //   nameRu: "Утилизация (убить)",
  //   name_eng: "Slay",
  //   cost: 10,
  //   item_type: "Предметы",
  //   category: "Предметы",
  //   grow: 0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1213921752204185630,
  //   emoji: 1253379481717047346,
  //   image_url:
  //     "https://cdn.discordapp.com/attachments/1197223722868805785/1215379313457631252/icons8-recycle-963.png?ex=65fc8930&is=65ea1430&hm=3eaf2a78662b6533c514a4aa24237bfa33d875dd48023f3d8fb5f6ccbffdf85e&",
  //   is_visible: 1,
  //   id: 4,
  //   server: 1,
  // },
  {
    nameRu: "Карнотавр",
    name_eng: "Carnotaurus",
    cost: 220,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194549796548132894,
    emoji: 1222077793840664617,
    image_url: carImg,
    is_visible: 1,
    id: 5,
    server: 1,
  },
  {
    nameRu: "Цератозавр",
    name_eng: "Ceratosaurus",
    cost: 270,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194545610737586236,
    emoji: 1222077791743508540,
    image_url: tcerImg,
    is_visible: 1,
    id: 6,
    server: 1,
  },
  {
    nameRu: "Дилофозавр",
    name_eng: "Dilophosaurus",
    cost: 180,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194550258370363462,
    emoji: 1222077797485514782,
    image_url: diloImg,
    is_visible: 1,
    id: 7,
    server: 1,
  },
  {
    nameRu: "Омнираптор",
    name_eng: "Omniraptor",
    cost: 100,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194550463962546207,
    emoji: 1222077795883159624,
    image_url: omniImg,
    is_visible: 1,
    id: 8,
    server: 1,
  },
  {
    nameRu: "Герреразавр",
    name_eng: "Herrerasaurus",
    cost: 100,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194550091156049970,
    emoji: 1222077800559935558,
    image_url: geroImg,
    is_visible: 1,
    id: 9,
    server: 1,
  },
  {
    nameRu: "Троодон",
    name_eng: "Troodon",
    cost: 50,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194550801482403890,
    emoji: 1222077810470817843,
    image_url: toroImg,
    is_visible: 1,
    id: 10,
    server: 1,
  },
  {
    nameRu: "Птеранодон",
    name_eng: "Pteranodon",
    cost: 30,
    item_type: "Динозавры",
    category: "Плотоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194550609270018139,
    emoji: 1222077812484341820,
    image_url: pterImg,
    is_visible: 1,
    id: 11,
    server: 1,
  },
  {
    nameRu: "Стегозавр",
    name_eng: "Stegosaurus",
    cost: 300,
    item_type: "Динозавры",
    category: "Травоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194551686161772554,
    emoji: 1222077814090760292,
    image_url: stegImg,
    is_visible: 1,
    id: 12,
    server: 1,
  },
  {
    nameRu: "Тенонтозавр",
    name_eng: "Tenontosaurus",
    cost: 200,
    item_type: "Динозавры",
    category: "Травоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194551492330393681,
    emoji: 1222078567513460767,
    image_url: tenImg,
    is_visible: 1,
    id: 13,
    server: 1,
  },
  {
    nameRu: "Пахицефалозавр",
    name_eng: "Pachycephalosaurus",
    cost: 150,
    item_type: "Динозавры",
    category: "Травоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1195394488928055397,
    emoji: 1222078569354625054,
    image_url: pahImg,
    is_visible: 1,
    id: 14,
    server: 1,
  },
  {
    nameRu: "Дриозавр",
    name_eng: "Dryosaurus",
    cost: 30,
    item_type: "Динозавры",
    category: "Травоядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1194551289464496128,
    emoji: 1222077816082923603,
    image_url: drioImg,
    is_visible: 1,
    id: 15,
    server: 1,
  },
  {
    nameRu: "Галлимимус",
    name_eng: "Gallimimus",
    cost: 100,
    item_type: "Динозавры",
    category: "Всеядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1195044410799423588,
    emoji: 1222077819870380063,
    image_url: galyaImg,
    is_visible: 1,
    id: 16,
    server: 1,
  },
  {
    nameRu: "Бэйпяозавр",
    name_eng: "Beipiaosaurus",
    cost: 30,
    item_type: "Динозавры",
    category: "Всеядные",
    grow: 100.0,
    cooldown_sec: 0,
    description_channel_id: 1195050720819421315,
    emoji: 1222077817920163861,
    image_url: bapeImg,
    is_visible: 1,
    id: 17,
    server: 1,
  },
  // {
  //   nameRu: "Дейнозух",
  //   name_eng: "Deinosuchus",
  //   cost: 300,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194544239925809204,
  //   emoji: 1222077808436711434,
  //   image_url: dainImg,
  //   is_visible: 1,
  //   id: 18,
  //   server: 2,
  // },
  // // {
  // //   nameRu: "Древняя эссенция",
  // //   name_eng: "Heal",
  // //   cost: 50,
  // //   item_type: "Предметы",
  // //   category: "Предметы",
  // //   grow: 0,
  // //   cooldown_sec: 0,
  // //   description_channel_id: 1213921994488291390,
  // //   emoji: 1253379484577693696,
  // //   image_url:
  // //     "https://cdn.discordapp.com/attachments/1197223722868805785/1215379517338550282/icons8-mana-96.png?ex=65fc8961&is=65ea1461&hm=bd43c909e7840d857e84b10896d69f92387a2aa7684dfeccfd20826f62c68fcd&",
  // //   is_visible: 1,
  // //   id: 19,
  // //   server: 2,
  // // },
  // // {
  // //   nameRu: "Желудок",
  // //   name_eng: "HungerFull",
  // //   cost: 20,
  // //   item_type: "Предметы",
  // //   category: "Предметы",
  // //   grow: 100.0,
  // //   cooldown_sec: 0,
  // //   description_channel_id: 1216084118748790908,
  // //   emoji: 1253410297516134522,
  // //   image_url:
  // //     "https://cdn.discordapp.com/attachments/1197223722868805785/1215379417250144346/icons8--96.png?ex=65fc8949&is=65ea1449&hm=813d8e7d15a8151c743b111daf4af1b93e125cdb6dfb582d748c14eac137e218&",
  // //   is_visible: 1,
  // //   id: 20,
  // //   server: 2,
  // // },
  // // {
  // //   nameRu: "Утилизация (убить)",
  // //   name_eng: "Slay",
  // //   cost: 10,
  // //   item_type: "Предметы",
  // //   category: "Предметы",
  // //   grow: 0,
  // //   cooldown_sec: 0,
  // //   description_channel_id: 1213921752204185630,
  // //   emoji: 1253379481717047346,
  // //   image_url:
  // //     "https://cdn.discordapp.com/attachments/1197223722868805785/1215379313457631252/icons8-recycle-963.png?ex=65fc8930&is=65ea1430&hm=3eaf2a78662b6533c514a4aa24237bfa33d875dd48023f3d8fb5f6ccbffdf85e&",
  // //   is_visible: 1,
  // //   id: 21,
  // //   server: 2,
  // // },
  // {
  //   nameRu: "Карнотавр",
  //   name_eng: "Carnotaurus",
  //   cost: 220,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194549796548132894,
  //   emoji: 1222077793840664617,
  //   image_url: carImg,
  //   is_visible: 1,
  //   id: 22,
  //   server: 2,
  // },
  // {
  //   nameRu: "Цератозавр",
  //   name_eng: "Ceratosaurus",
  //   cost: 270,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194545610737586236,
  //   emoji: 1222077791743508540,
  //   image_url: tcerImg,
  //   is_visible: 1,
  //   id: 23,
  //   server: 2,
  // },
  // {
  //   nameRu: "Дилофозавр",
  //   name_eng: "Dilophosaurus",
  //   cost: 180,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194550258370363462,
  //   emoji: 1222077797485514782,
  //   image_url: diloImg,
  //   is_visible: 1,
  //   id: 24,
  //   server: 2,
  // },
  // {
  //   nameRu: "Омнираптор",
  //   name_eng: "Omniraptor",
  //   cost: 100,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194550463962546207,
  //   emoji: 1222077795883159624,
  //   image_url: omniImg,
  //   is_visible: 1,
  //   id: 25,
  //   server: 2,
  // },
  // {
  //   nameRu: "Герреразавр",
  //   name_eng: "Herrerasaurus",
  //   cost: 100,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194550091156049970,
  //   emoji: 1222077800559935558,
  //   image_url: geroImg,
  //   is_visible: 1,
  //   id: 26,
  //   server: 2,
  // },
  // {
  //   nameRu: "Троодон",
  //   name_eng: "Troodon",
  //   cost: 50,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194550801482403890,
  //   emoji: 1222077810470817843,
  //   image_url: toroImg,
  //   is_visible: 1,
  //   id: 27,
  //   server: 2,
  // },
  // {
  //   nameRu: "Птеранодон",
  //   name_eng: "Pteranodon",
  //   cost: 30,
  //   item_type: "Динозавры",
  //   category: "Плотоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194550609270018139,
  //   emoji: 1222077812484341820,
  //   image_url: pterImg,
  //   is_visible: 1,
  //   id: 28,
  //   server: 2,
  // },
  // {
  //   nameRu: "Стегозавр",
  //   name_eng: "Stegosaurus",
  //   cost: 300,
  //   item_type: "Динозавры",
  //   category: "Травоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194551686161772554,
  //   emoji: 1222077814090760292,
  //   image_url: stegImg,
  //   is_visible: 1,
  //   id: 29,
  //   server: 2,
  // },
  // {
  //   nameRu: "Тенонтозавр",
  //   name_eng: "Tenontosaurus",
  //   cost: 200,
  //   item_type: "Динозавры",
  //   category: "Травоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194551492330393681,
  //   emoji: 1222078567513460767,
  //   image_url: tenImg,
  //   is_visible: 1,
  //   id: 30,
  //   server: 2,
  // },
  // {
  //   nameRu: "Пахицефалозавр",
  //   name_eng: "Pachycephalosaurus",
  //   cost: 150,
  //   item_type: "Динозавры",
  //   category: "Травоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1195394488928055397,
  //   emoji: 1222078569354625054,
  //   image_url: pahImg,
  //   is_visible: 1,
  //   id: 31,
  //   server: 2,
  // },
  // {
  //   nameRu: "Дриозавр",
  //   name_eng: "Dryosaurus",
  //   cost: 30,
  //   item_type: "Динозавры",
  //   category: "Травоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1194551289464496128,
  //   emoji: 1222077816082923603,
  //   image_url: drioImg,
  //   is_visible: 1,
  //   id: 32,
  //   server: 2,
  // },
  // {
  //   nameRu: "Галлимимус",
  //   name_eng: "Gallimimus",
  //   cost: 100,
  //   item_type: "Динозавры",
  //   category: "Всеядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1195044410799423588,
  //   emoji: 1222077819870380063,
  //   image_url: galyaImg,
  //   is_visible: 1,
  //   id: 33,
  //   server: 2,
  // },
  // {
  //   nameRu: "Бэйпяозавр",
  //   name_eng: "Beipiaosaurus",
  //   cost: 30,
  //   item_type: "Динозавры",
  //   category: "Всеядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1195050720819421315,
  //   emoji: 1222077817920163861,
  //   image_url: bapeImg,
  //   is_visible: 1,
  //   id: 34,
  //   server: 2,
  // },
  // {
  //   nameRu: "Диаблоцератопс",
  //   name_eng: "Diabloceratops",
  //   cost: 300,
  //   item_type: "Динозавры",
  //   category: "Травоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1270384957658890311,
  //   emoji: 1270387270083543101,
  //   image_url: diabloImg,
  //   is_visible: 1,
  //   id: 41,
  //   server: 1,
  // },
  // {
  //   nameRu: "Диаблоцератопс",
  //   name_eng: "Diabloceratops",
  //   cost: 300,
  //   item_type: "Динозавры",
  //   category: "Травоядные",
  //   grow: 100.0,
  //   cooldown_sec: 0,
  //   description_channel_id: 1270384957658890311,
  //   emoji: 1270387270083543101,
  //   image_url: diabloImg,
  //   is_visible: 1,
  //   id: 42,
  //   server: 2,
  // },
];

export const catalogData = [...dinosaursData];
